function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Created by liushuai on 2019-11-15
 *
 */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'mkui-fd';

var Ellipsis = function Ellipsis(props) {
  var value = props.value,
      prefixCls = props.prefixCls;
  value = String(value);
  var myRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShow = _useState2[0],
      setIsShow = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOver = _useState4[0],
      setIsOver = _useState4[1];

  useEffect(function () {
    var elementWidth = myRef.current.offsetWidth;
    var parentWidth = myRef.current.parentElement.offsetWidth;

    if (elementWidth > parentWidth) {
      setIsOver(true);
    }
  }, [myRef.current]);
  return React.createElement(Tooltip, {
    title: value,
    visible: isShow
  }, React.createElement("span", {
    className: isOver ? "".concat(prefixCls, "-over") : "".concat(prefixCls, "-normal"),
    ref: myRef,
    onMouseEnter: function onMouseEnter() {
      if (isOver) {
        setIsShow(true);
      }
    },
    onMouseLeave: function onMouseLeave() {
      return setIsShow(false);
    }
  }, value));
};

Ellipsis.propTypes = {
  prefixCls: PropTypes.string,
  value: PropTypes.string
};
Ellipsis.defaultProps = {
  prefixCls: 'mkui-ellipsis',
  value: ''
};
export default Ellipsis;
//# sourceMappingURL=Ellipsis.js.map
